// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { rem } from 'polished';

// Components
// import Component from '~/components/componentName';

/**********
 ** Component: NavigationLink
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const NavigationLink = props => {
	return (
		<Item button={props.button}>
			<Anchor exact={props.exact} to={`${props.to}`} title={`Go to ${props.title}`} activeClassName="is--active">
				{props.title}
			</Anchor>
		</Item>
	);
};

// Styled Components
const fadeInDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-4rem);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Item = styled.li`
	display: inline-flex;
	list-style-type: none;
	line-height: 100%;
	padding: 0;
	margin-top: 0;
	margin-right: ${rem('16px')};
	margin-bottom: 0;
	margin-left: ${rem('16px')};
	align-items: center;
	justify-content: center;
	position: relative;
	text-align: center;
	flex-wrap: wrap;
	min-width: ${rem('96px')};
	animation-name: ${fadeInDown};
	animation-duration: 750ms;
	animation-timing-function: ${props => props.theme.easeOutBack};
	animation-fill-mode: forwards;
	animation-delay: 0;
	border: ${props => (props.button ? '2px solid white' : '')};
	border-radius: ${props => (props.button ? '36px !important' : '')};

	&:nth-child(1) {
		animation-delay: 125ms;
	}

	&:nth-child(2) {
		animation-delay: 250ms;
	}

	&:nth-child(3) {
		animation-delay: 375ms;
	}

	a {
		padding: ${props => (props.button ? '8px 16px' : '8px')};
		transition: all 200ms ease-in-out;

		&:hover {
			width: ${props => (props.button ? '100%' : 'auto')};
			background-color: ${props => (props.button ? 'hsla(0, 0%, 100%, 1)' : 'hsla(0, 0%, 100%, 0.2)')};
			border-bottom-style: solid;
			border-bottom-width: 2px;
			border-bottom-color: hsla(0, 0%, 100%, 0.4);
			border-radius: ${props => (props.button ? '42px' : 'none')};
			color: ${props => (props.button ? props.theme.primaryColor : props.theme.white)};
		}

		&.is--active {
			&:hover {
				background-color: ${props => (props.button ? 'hsla(0, 0%, 100%, 1)' : 'transparent')};
				color: ${props => (props.button ? props.theme.primaryColor : props.theme.white)};
				border-bottom: ${props => (props.button ? 'none' : '2px solid hsla(0, 0%, 100%, 1)')};
			}
			border-radius: ${props => (props.button ? '42px' : 'none')};
			background-color: ${props => (props.button ? 'hsla(0, 0%, 100%, 1)' : 'transparent')};
			color: ${props => (props.button ? props.theme.primaryColor : props.theme.white)};
			border-bottom-style: solid;
			border-bottom-width: 2px;
			border-bottom-color: ${props => (props.button ? 'none' : props.theme.white)};
		}
	}
`;

const Anchor = styled(NavLink)`
	font-family: inherit;
	font-size: ${rem('22px')};
	letter-spacing: 0.46px;
	color: ${props => props.theme.white};
	font-weight: 600;
	line-height: 100%;
	text-decoration: none;
	align-items: center;
	justify-content: center;
	display: flex;
	overflow: hidden;
	position: relative;
	transition: transform 125ms ease-out;

	&:active {
		outline: 1;
	}
`;

// Prop Types
NavigationLink.defaultProps = {
	button: false,
	exact: false,
	to: '#',
	title: 'anchor title',
};

NavigationLink.propTypes = {
	button: PropTypes.bool,
	exact: PropTypes.bool,
	to: PropTypes.string,
	title: PropTypes.string,
};

export default NavigationLink;



// WEBPACK FOOTER //
// ./src/components/ui/navigation/header/navigation-link.jsx